import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import decode from "jwt-decode";
import { composeWithDevTools } from "redux-devtools-extension";
import { CookiesProvider } from "react-cookie";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import rootReducer from "./rootReducer";
import { userLoggedIn, addUserAccount } from "./actions/auth";
import { uiLoaded } from "./actions/search";
import { userGlb } from "./actions/userGlb";
import setAuthorizationHeader from "./utils/setAuthorizationHeader";
import { getUserAccount } from "./metadata/userAccount";
import "./App.css";

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

const MyApp = (props) => (
  <CookiesProvider>
    <App {...props} />
  </CookiesProvider>
);

if (localStorage.appToken) {
  const payload = decode(localStorage.appToken);
  const user = {
    token: localStorage.appToken,
    userid: payload.unique_name,
  };
  const date = new Date();
  date.setMilliseconds(0);
  date.setMinutes(date.getMinutes() + (payload.exp - payload.iat) / 60);
  localStorage.expires = date.getTime() / 1000;
  setAuthorizationHeader(localStorage.appToken);
  store.dispatch(userLoggedIn(user));
  store.dispatch(addUserAccount(getUserAccount()));
}

if (localStorage.appToken) {
  setAuthorizationHeader(localStorage.appToken);
  if (localStorage.userGlb)
    store.dispatch(userGlb(JSON.parse(localStorage.userGlb)));
  if (localStorage.searchUiData)
    store.dispatch(uiLoaded(JSON.parse(localStorage.searchUiData)));
}

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Route component={MyApp} />
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js